/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PathologyBaseService } from '../pathology-base-service';
import { PathologyApiConfiguration } from '../pathology-api-configuration';
import { PathologyStrictHttpResponse } from '../pathology-strict-http-response';

import { FormStatus } from '../models/form-status';
import { pathologyIdDelete } from '../fn/pathology/pathology-id-delete';
import { PathologyIdDelete$Params } from '../fn/pathology/pathology-id-delete';
import { pathologyIdGet } from '../fn/pathology/pathology-id-get';
import { PathologyIdGet$Params } from '../fn/pathology/pathology-id-get';
import { pathologyIdGetStatusGet } from '../fn/pathology/pathology-id-get-status-get';
import { PathologyIdGetStatusGet$Params } from '../fn/pathology/pathology-id-get-status-get';
import { pathologyIdRevertToDraftPost } from '../fn/pathology/pathology-id-revert-to-draft-post';
import { PathologyIdRevertToDraftPost$Params } from '../fn/pathology/pathology-id-revert-to-draft-post';
import { pathologyIdSubmitPost } from '../fn/pathology/pathology-id-submit-post';
import { PathologyIdSubmitPost$Params } from '../fn/pathology/pathology-id-submit-post';
import { pathologyInitializePathologyRequestPost } from '../fn/pathology/pathology-initialize-pathology-request-post';
import { PathologyInitializePathologyRequestPost$Params } from '../fn/pathology/pathology-initialize-pathology-request-post';
import { pathologyPost } from '../fn/pathology/pathology-post';
import { PathologyPost$Params } from '../fn/pathology/pathology-post';
import { pathologySearchPathologyRequestPost } from '../fn/pathology/pathology-search-pathology-request-post';
import { PathologySearchPathologyRequestPost$Params } from '../fn/pathology/pathology-search-pathology-request-post';
import { RequestDataModel } from '../models/request-data-model';
import { RequestGridResultModelSearchResultModel } from '../models/request-grid-result-model-search-result-model';

@Injectable({ providedIn: 'root' })
export class PATHPathologyService extends PathologyBaseService {
  constructor(config: PathologyApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `pathologyInitializePathologyRequestPost()` */
  static readonly PathologyInitializePathologyRequestPostPath = '/Pathology/InitializePathologyRequest';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pathologyInitializePathologyRequestPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  pathologyInitializePathologyRequestPost$Response(params?: PathologyInitializePathologyRequestPost$Params, context?: HttpContext): Observable<PathologyStrictHttpResponse<void>> {
    return pathologyInitializePathologyRequestPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pathologyInitializePathologyRequestPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  pathologyInitializePathologyRequestPost(params?: PathologyInitializePathologyRequestPost$Params, context?: HttpContext): Observable<void> {
    return this.pathologyInitializePathologyRequestPost$Response(params, context).pipe(
      map((r: PathologyStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `pathologySearchPathologyRequestPost()` */
  static readonly PathologySearchPathologyRequestPostPath = '/Pathology/SearchPathologyRequest';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pathologySearchPathologyRequestPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  pathologySearchPathologyRequestPost$Response(params?: PathologySearchPathologyRequestPost$Params, context?: HttpContext): Observable<PathologyStrictHttpResponse<RequestGridResultModelSearchResultModel>> {
    return pathologySearchPathologyRequestPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pathologySearchPathologyRequestPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  pathologySearchPathologyRequestPost(params?: PathologySearchPathologyRequestPost$Params, context?: HttpContext): Observable<RequestGridResultModelSearchResultModel> {
    return this.pathologySearchPathologyRequestPost$Response(params, context).pipe(
      map((r: PathologyStrictHttpResponse<RequestGridResultModelSearchResultModel>): RequestGridResultModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `pathologyIdGet()` */
  static readonly PathologyIdGetPath = '/Pathology/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pathologyIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  pathologyIdGet$Response(params: PathologyIdGet$Params, context?: HttpContext): Observable<PathologyStrictHttpResponse<RequestDataModel>> {
    return pathologyIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pathologyIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pathologyIdGet(params: PathologyIdGet$Params, context?: HttpContext): Observable<RequestDataModel> {
    return this.pathologyIdGet$Response(params, context).pipe(
      map((r: PathologyStrictHttpResponse<RequestDataModel>): RequestDataModel => r.body)
    );
  }

  /** Path part for operation `pathologyIdDelete()` */
  static readonly PathologyIdDeletePath = '/Pathology/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pathologyIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  pathologyIdDelete$Response(params: PathologyIdDelete$Params, context?: HttpContext): Observable<PathologyStrictHttpResponse<void>> {
    return pathologyIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pathologyIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pathologyIdDelete(params: PathologyIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.pathologyIdDelete$Response(params, context).pipe(
      map((r: PathologyStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `pathologyPost()` */
  static readonly PathologyPostPath = '/Pathology';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pathologyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  pathologyPost$Response(params?: PathologyPost$Params, context?: HttpContext): Observable<PathologyStrictHttpResponse<void>> {
    return pathologyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pathologyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  pathologyPost(params?: PathologyPost$Params, context?: HttpContext): Observable<void> {
    return this.pathologyPost$Response(params, context).pipe(
      map((r: PathologyStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `pathologyIdSubmitPost()` */
  static readonly PathologyIdSubmitPostPath = '/Pathology/{id}/Submit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pathologyIdSubmitPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  pathologyIdSubmitPost$Response(params: PathologyIdSubmitPost$Params, context?: HttpContext): Observable<PathologyStrictHttpResponse<void>> {
    return pathologyIdSubmitPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pathologyIdSubmitPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  pathologyIdSubmitPost(params: PathologyIdSubmitPost$Params, context?: HttpContext): Observable<void> {
    return this.pathologyIdSubmitPost$Response(params, context).pipe(
      map((r: PathologyStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `pathologyIdRevertToDraftPost()` */
  static readonly PathologyIdRevertToDraftPostPath = '/Pathology/{id}/RevertToDraft';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pathologyIdRevertToDraftPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  pathologyIdRevertToDraftPost$Response(params: PathologyIdRevertToDraftPost$Params, context?: HttpContext): Observable<PathologyStrictHttpResponse<void>> {
    return pathologyIdRevertToDraftPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pathologyIdRevertToDraftPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pathologyIdRevertToDraftPost(params: PathologyIdRevertToDraftPost$Params, context?: HttpContext): Observable<void> {
    return this.pathologyIdRevertToDraftPost$Response(params, context).pipe(
      map((r: PathologyStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `pathologyIdGetStatusGet()` */
  static readonly PathologyIdGetStatusGetPath = '/Pathology/{id}/GetStatus';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pathologyIdGetStatusGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  pathologyIdGetStatusGet$Response(params: PathologyIdGetStatusGet$Params, context?: HttpContext): Observable<PathologyStrictHttpResponse<FormStatus | null>> {
    return pathologyIdGetStatusGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pathologyIdGetStatusGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pathologyIdGetStatusGet(params: PathologyIdGetStatusGet$Params, context?: HttpContext): Observable<FormStatus | null> {
    return this.pathologyIdGetStatusGet$Response(params, context).pipe(
      map((r: PathologyStrictHttpResponse<FormStatus | null>): FormStatus | null => r.body)
    );
  }

}
